import PhoneSVG from '../../assets/svg/phone.svg';
export default PhoneSVG;
